"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cleanArray = cleanArray;
exports.convertDate = convertDate;
exports.convertDateBR = convertDateBR;
exports.createBase64Image = createBase64Image;
exports.dateMonthYearFormat = dateMonthYearFormat;
exports.deepClone = deepClone;
exports.fixedActivities = fixedActivities;
exports.formatCPF = formatCPF;
exports.generateRandomName = generateRandomName;
exports.getFormData = getFormData;
exports.param = param;
exports.validStatusApuration = validStatusApuration;
var _validate = require("./validate");
var _moment = _interopRequireDefault(require("moment"));
var _constants = require("@/config/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * @param {Array} actual
 * @returns {Array}
 */
function cleanArray(actual) {
  var newArray = [];
  for (var i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }
  return newArray;
}

/**
 * @param {Object} json
 * @returns {Array}
 */
function param(json) {
  if (!json) return '';
  return cleanArray(Object.keys(json).map(function (key) {
    if (json[key] === undefined) return '';
    return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
  })).join('&');
}
var typesActivities = {
  PROCESSING: 'AWAITING',
  READY_TO_PROCESS: 'PROCESSING',
  FINISHED: 'FINISHED',
  ERROR: 'ERROR'
};

/**
 * @param {Array} array
 * @returns {Array}
 */
function fixedActivities(array) {
  return array && array.map(function (item) {
    var files = {
      file: _objectSpread(_objectSpread({}, item), {}, {
        sentDate: item.importedAt,
        generatedName: item.generatedName + '.' + item.extension,
        processingEndDate: item.completedAt,
        status: typesActivities[item.processingStatus],
        size: item.fileSize
      }),
      campaign: _objectSpread({}, item.campaign)
    };
    if (item.campaign) {
      files = _objectSpread(_objectSpread({}, files), {}, {
        campaign: _objectSpread({}, item.campaign)
      });
    }
    return files;
  });
}

/**
 * copy lodash _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
function deepClone(source) {
  if (!source || _typeof(source) !== 'object') {
    throw new Error('error arguments', 'deepClone');
  }
  var targetObj = {};
  targetObj = source.constructor === Array ? [] : {};
  Object.keys(source).forEach(function (keys) {
    if (source[keys] && _typeof(source[keys]) === 'object') {
      targetObj[keys] = deepClone(source[keys]);
    } else {
      targetObj[keys] = source[keys];
    }
  });
  return targetObj;
}

/**
 * Format CPF mask
 * @param {string} str
 * @returns {Object}
 */
function formatCPF(str) {
  var cpf = str.toString();
  var strCPF = (0, _validate.replaceAll)(cpf, '.', '');
  strCPF = (0, _validate.replaceAll)(strCPF, '-', '');
  return strCPF;
}

/**
 * Conver Json to form-data
 * @param {string} str
 * @returns {Object}
 */
function getFormData(val) {
  var formData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new FormData();
  var namespace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return new Promise(function (resolve, reject) {
    if (typeof val !== 'undefined' && val !== null) {
      if (val instanceof Date) {
        formData.append(namespace, val.toISOString());
      } else if (val instanceof Array) {
        for (var i = 0; i < val.length; i++) {
          var element = val[i];
          getFormData(element, formData, namespace + "[".concat(i, "]"));
        }
      } else if (_typeof(val) === 'object' && !(val instanceof File)) {
        for (var propertyName in val) {
          if (val.hasOwnProperty(propertyName)) {
            getFormData(val[propertyName], formData, namespace ? namespace + '.' + propertyName : propertyName);
          }
        }
      } else if (val instanceof File) {
        formData.append(namespace, val);
      } else {
        formData.append(namespace, val.toString());
      }
    }
    return resolve(formData);
  });
}
function dateMonthYearFormat(value) {
  var date = (0, _moment.default)(String(value));
  return date.format('MM/YYYY');
}
function validStatusApuration(val) {
  var status = '';
  switch (val) {
    case 0:
      status = _constants.STATUS_APURATION.UNAPPROVED;
      break;
    case 1:
      status = _constants.STATUS_APURATION.PENDING;
      break;
    case 2:
      status = _constants.STATUS_APURATION.APPROVED;
      break;
    default:
      status = null;
      break;
  }
  return status;
}

/**
 * replace all strings
 * @param {string} date
 * @param {string} format
 * @returns {string}
 */
function convertDate(date) {
  if (date) {
    var d = date.split('/');
    var dataFormat = "".concat(d[2], "-").concat(d[1], "-").concat(d[0]);
    return (0, _moment.default)(dataFormat).toISOString();
  }
  return null;
}

/**
 * convert Date BR
 * @param {string} date
 * @param {string} format
 * @returns {string}
 */
function convertDateBR(date) {
  if (date) {
    return (0, _moment.default)(date).format('DD/MM/YYYY');
  }
  return '';
}

/**
 * convert Date BR
 * @param {string} date
 * @param {string} format
 * @returns {string}
 */
function generateRandomName(length) {
  var result = '';
  var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

/**
 * convert file to base64
 * @param {string} date
 * @param {string} format
 * @returns {string}
 */
function createBase64Image(inputFile) {
  var temporaryFileReader = new FileReader();
  return new Promise(function (resolve, reject) {
    temporaryFileReader.onerror = function () {
      temporaryFileReader.abort();
      reject(new DOMException('Problem parsing input file.'));
    };
    temporaryFileReader.onload = function () {
      resolve(temporaryFileReader.result);
    };
    temporaryFileReader.readAsDataURL(inputFile);
  });
}